import React, { useEffect } from 'react';
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';
import { useDispatch, useSelector } from 'react-redux';
import { setHasDAABAccess, setHideDealerPurchase, setBundlePricingEnabled } from '../redux/connectedComponent/loginDetails/loginDetails.slice';
import { environmentURLs } from '../components/common/CaptureEnvironment';

function CheckDaabAccessFeatureFlag() {
  const dispatch = useDispatch();

  const dealerAccessFeatureFlag = useFeatureFlag(
    environmentURLs.REACT_APP_DAAB_FEATURE_FLAG
  );

  const hideDealerPurchaseFeatureFlag = useFeatureFlag(
    environmentURLs.REACT_APP_DAAB_HIDE_DEALER_PURCHASE
  );

  const bundlePricingEnabled = useFeatureFlag('BUNDLE_PRICING_ENABLED') 

  const { userEmail, fortellisEnterpriseEntityId } = useSelector(
    (state) => state.loginDetailsSlice
  );

  useEffect(() => {
    if (!dealerAccessFeatureFlag) return;

    let hasDaabAccess = false;
    let parsedFeatureFlag;

    try {
      parsedFeatureFlag =
        typeof dealerAccessFeatureFlag === 'string'
          ? JSON.parse(dealerAccessFeatureFlag)
          : dealerAccessFeatureFlag;
    } catch (error) {
      console.error('Failed to parse dealerAccessFeatureFlag:', error);
      return;
    }

    if (
      parsedFeatureFlag.type === 'user' &&
      Array.isArray(parsedFeatureFlag.user_ids)
    ) {
      hasDaabAccess = parsedFeatureFlag.user_ids.includes(userEmail);
    } else if (
      parsedFeatureFlag.type === 'org' &&
      Array.isArray(parsedFeatureFlag.org_ids)
    ) {
      hasDaabAccess = parsedFeatureFlag.org_ids.includes(
        fortellisEnterpriseEntityId
      );
    }

    dispatch(setHasDAABAccess(hasDaabAccess));
  }, [
    dealerAccessFeatureFlag,
    userEmail,
    fortellisEnterpriseEntityId,
    dispatch,
  ]);

useEffect(() => {
    if (!hideDealerPurchaseFeatureFlag) return;

    let hideDealerPurchase = false;
    let parsedHideDealerPurchase;

    try {
      parsedHideDealerPurchase =
        typeof hideDealerPurchaseFeatureFlag === 'string'
          ? JSON.parse(hideDealerPurchaseFeatureFlag)
          : hideDealerPurchaseFeatureFlag;
    } catch (error) {
      console.error('Failed to parse hideDealerPurchaseFeatureFlag:', error);
      return;
    }

    if (
      parsedHideDealerPurchase?.type === 'user' &&
      Array.isArray(parsedHideDealerPurchase.user_ids)
    ) {
      hideDealerPurchase = parsedHideDealerPurchase.user_ids.includes(userEmail);
    } else if (
      parsedHideDealerPurchase?.type === 'org' &&
      Array.isArray(parsedHideDealerPurchase.org_ids)
    ) {
      hideDealerPurchase = parsedHideDealerPurchase.org_ids.includes(
        fortellisEnterpriseEntityId
      );
    }

    dispatch(setHideDealerPurchase(hideDealerPurchase));
  }, [
    hideDealerPurchaseFeatureFlag,
    userEmail,
    fortellisEnterpriseEntityId,
    dispatch,
  ]);

  useEffect(() => {
    if (bundlePricingEnabled !== undefined) {
      dispatch(setBundlePricingEnabled(!!bundlePricingEnabled));
    }
  }, [bundlePricingEnabled, dispatch]);

  return null;
}

export { CheckDaabAccessFeatureFlag };
